import React from "react";
import { useNavigate } from "react-router-dom";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";
import "./Styles.css";

const AboutUs = () => {
  const navigate = useNavigate();
  const [headingRef, headingVisible] = useScrollAnimation({ threshold: 0.2 });
  const [contentRef, contentVisible] = useScrollAnimation({ threshold: 0.1 });

  return (
    <section className="aboutus">
      <div className="container">
        {/* HEADER — flip: title LEFT, eyebrow RIGHT (img1 pattern) */}
        <div
          ref={headingRef}
          className={`section-header section-header--flip fade-in-up ${headingVisible ? 'visible' : ''}`}
        >
          <div className="sh-title">
            <h2 className="section-title">
              TOGETHER, WE TAKE GOD'S GLORY TO THE NATIONS
            </h2>
          </div>
          <div className="sh-label">
            <span className="eyebrow">About Us</span>
          </div>
        </div>
      </div>

      <div className="au-hero">
        <div className="au-overlay">
          <div className="container">
            <div
              ref={contentRef}
              className={`au-text fade-in-up ${contentVisible ? 'visible' : ''}`}
            >
              <h2>
                We are a church that believes in Jesus,
                a church that loves God and people
              </h2>
              <p>
                Being in Christ Embassy is more than being in a church — it's God's
                vision. When you worship at Christ Embassy, you learn more than just
                the letters; rather you catch the Spirit of the Word.
              </p>
              <button className="au-btn" onClick={() => navigate('/about')}>
                Know More
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
